"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Record = exports.Array = exports.Value = exports.Primitive = exports.NAMESPACE = void 0;
const effect_1 = require("effect");
exports.NAMESPACE = 'Json';
exports.Primitive = effect_1.Schema.Union(effect_1.Schema.Boolean, effect_1.Schema.Number, effect_1.Schema.String, effect_1.Schema.Null).annotations({
    identifier: `${exports.NAMESPACE}.Primitive`,
});
exports.Value = effect_1.Schema.suspend(() => effect_1.Schema.Union(exports.Primitive, exports.Array, exports.Record)).annotations({
    identifier: `${exports.NAMESPACE}.Value`,
});
exports.Array = effect_1.Schema.Array(exports.Value).annotations({
    identifier: `${exports.NAMESPACE}.Array`,
});
exports.Record = effect_1.Schema.Record({ key: effect_1.Schema.String, value: exports.Value }).annotations({
    identifier: `${exports.NAMESPACE}.Record`,
});
//# sourceMappingURL=json.js.map